/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerAnalyticsConfig } from '../../config/header.config';
import { loadingAnalyticsConfig } from '../../config/loading.config';

export interface IStaticPageAnalyticsPluginMethods extends IPluginMethodMap {
  getStaticPageAnalyticsSync(args?: any): any;
}

export class StaticPageAnalyticsPlugin implements IAgentPlugin {
  readonly methods: IStaticPageAnalyticsPluginMethods;

  constructor() {
    this.methods = {
      getStaticPageAnalyticsSync: this.getStaticPageAnalyticsSync.bind(this),
    };
  }

  getStaticPageAnalyticsSync(args?: any) {
    return {
      // error:StaticPageAnalyticsConfig
      header: headerAnalyticsConfig,
      loading: loadingAnalyticsConfig,
    };
  }
}
